import {
  Component,
  ContentChildren,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
} from "@angular/core";
import { WidgetMenuType, WidgetType } from "@bitwarden/web-vault/app/models/types/widget.types";

@Component({
  selector: "app-widget",
  templateUrl: "widget.component.html",
})
export class WidgetComponent implements OnInit {
  @Input() titleClass?: string;
  @Input() backgroundClass?: string;
  @Input() title: string;
  @Input() iconName: string;
  @Input() hideIcon: boolean = false;
  @Input() type: WidgetType = "static";
  @Input() menu?: {
    type: WidgetMenuType;
    options: { displayValue?: string; value: string; isSelected?: boolean }[];
  };
  @Output() onClick: EventEmitter<string> = new EventEmitter<string>();

  @ContentChildren("titleWidget", { descendants: true }) titleWidgetContent: QueryList<any>;
  @ContentChildren("action", { descendants: true }) actionContent: QueryList<any>;

  get hasHeaderContent(): boolean {
    return (
      !!this.title ||
      !this.hideIcon ||
      (this.titleWidgetContent && this.titleWidgetContent.length > 0) ||
      !!this.menu ||
      (this.actionContent && this.actionContent.length > 0)
    );
  }

  ngOnInit() {
    if (this.menu?.options.length > 0) {
      this.setSelectedOption(this.menu.options[0].value);
    }
  }

  setSelectedOption(value: string) {
    this.menu.options.forEach((option) => {
      option.isSelected = value == option.value;
    });
  }

  onOptionClick(value: string) {
    this.setSelectedOption(value);
    this.onClick.emit(value);
  }
}
